<template>
    <gofix-card class="mb-0 contractCardFullHeight" fullContent>
        <gofix-default-table 
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @row-click="goToDetail"
            @delete-items="deleteItems"
            @import-items="importItems"
            @export="exportItems"
            @new-item="openCreateItemModal"
            ref="gofixTable">
            <template slot="gofix_table:effective_date" slot-scope="row">
                {{row.item.effective_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:unit_price" slot-scope="row">
                {{ row.item.unit_price | formatMoney }}
            </template>
        </gofix-default-table>

        <b-modal 
            id="modal-create-item"
            modal-class="modal-create" 
            title="Create New SOR" 
            :no-close-on-backdrop="true" 
            hide-footer 
            centered 
            v-model="modal.open">
            <div v-bind:class="{'run-loading': modal.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input label="SOR code" v-model="sorItem.sor_code"></gofix-form-input>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-tree
                                label="Service Category"
                                :multiple="false"
                                :options="services"
                                :load-options="loadOptionsService"
                                :normalizer="normalizerService"
                                search-nested
                                valueFormat="object"
                                v-model="sorItem.service_category"
                                placeholder=""
                                ref="input">
                            </gofix-form-tree>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input label="Description 01" v-model="sorItem.description_one"></gofix-form-input>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input label="Description 02" v-model="sorItem.description_two"></gofix-form-input>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-number label="Unit price" desc=" " v-model="sorItem.unit_price_tmp" prefix="$"></gofix-form-input-number>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input label="Unit of Measurement" v-model="sorItem.unit_of_measurement"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="MORE" @click="goToDetail(sorItem)" noBorder dark></gofix-button>
                    <gofix-button label="APPLY" @click="updateItem" :disabled="$disabledCreateOrUpdate(this.sorItem, $accessModule.sor)" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modals.export.process}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
    </gofix-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js';

export default {
    name: 'sor-items',
    components: {},
    props:{
        group: {
            type: Object,
            required: true,
            default: () => {}
        },
        terms: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data () {
        let filter = JSON.parse(JSON.stringify(filters['sor_master']));
        filter.is_maintenance.value = false;
        return {
            first_load: true,
            tableItems: [],
            tableConfig:{
                name: 'client-contract-sor',
                controls:{
                    create: this.$checkRole(this.$accessModule.sor, 'create'),
                    delete: this.$checkRole(this.$accessModule.sor, 'delete'),
                    tableImport: this.$checkRole(this.$accessModule.sor, 'create') && this.$checkRole(this.$accessModule.sor, 'update'),
                    tableExport: true
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "sor_code",
                sortDirection: "asc",
                itemSelected: [],
            },
            modal: {
                open: false,
                loading: false
            },
            modals:{
                export:{
                    open:false,
                    loading:false,
                    process:'Creating file csv',
                    title: 'Export Data'
                },
            }
        }
    },
    watch: {
        group: function(val, old) {
            if((!old || !old.id) || (old && val && old.id && val.id && val.id != old.id)) {
                this.$refs.gofixTable.reloadTableItems();
            }           
        },
        "currentRoles": function(val,old){
            this.tableConfig.controls = {
                create: this.$checkRole(this.$accessModule.sor, 'create'),
                delete: this.$checkRole(this.$accessModule.sor, 'delete'),
                tableImport: this.$checkRole(this.$accessModule.sor, 'create') && this.$checkRole(this.$accessModule.sor, 'update'),
            }
        },
        ClientContractID: function(val, old) {
            if(old && val && old.id && val.id && old.id != val.id)
                this.$store.dispatch('v2SorController/getService', { contract_id: val.id, service_id: 0 });
        }
    },
    computed: {
        ...mapGetters({
            sorItem:          'v2SorController/sorItem',
            services:         'v2SorController/serviceCategories',
            currentRoles:     'AuthController/roles',
            ClientContractID: 'ContractController/ClientContractID',
        }),
    },
    created(){
        this.$store.dispatch('v2SorController/getService', { contract_id: this.$route.params.id, service_id: 0 });
    },
    methods:{
        /*--- Table event-------------------------------*/
        async getTableData(callback){
            const { tableRequest , resolve,reject } = await callback();
            if(this.first_load || (!this.group || !this.group.id)){
                this.first_load = false;
                resolve();
                return;
            }
            
            if(tableRequest.filter && tableRequest.filter.id && this.group && this.group.id){
                tableRequest.filter.id.value = this.group.id;
            } else {
                tableRequest.filter.id.value = null;
            }

            await this.$store.dispatch("v2SorController/getItems", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the SOR", "danger");
                reject();
            })
        },
        openCreateItemModal(){
            this.$store.commit("v2SorController/setItem",null);
            if(this.group && this.group.id) {
                this.sorItem.sor_group    = this.group;
                this.sorItem.sor_group_id = this.group.id;
            } else {
                this.sorItem.sor_group_id = this.ClientContractID.sor_group_root_id;
            }
            this.modal.open = true;
        },
        goToDetail(item){
            let id = item.id || 0;
            if(!item) {
                this.$store.commit("v2SorController/setItem", this.sorItem);
            }
            this.$router.push({ name:"edit-sor", params: { sor_id: id } });
        },
        async deleteItems(callback){
            const { ids,filter, resolve, reject } = await callback();
            this.$store.dispatch("v2SorController/deleteItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'sor'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        async importItems(callback){
            const { file, resolve, reject } = await callback();
            await this.$store.dispatch(`v2SorController/importSOR`, {
                fileImportSOR: file,
                id : this.terms.id
            })
            .then(response => {
                let variant = 'success';
                let msg = this.$notificationV2('importing', 'sor');
                let result = response.data.data;
                if(result.data && result.data.count && result.data.count.failed ) {
                    variant = 'danger';
                    msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                }

                this.$alertNotification(msg, variant);
                this.$emit("importSuccess");
                resolve();
            })
            .catch(error => {
                reject(error);
            });
        },
        async exportItems(){
            let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
            let that = this;
            this.modals.export.open = true;
            this.modals.export.process = "Creating file csv";

            global.axios.get(`/api/sor/export`, {
                params: request,
                responseType: 'blob',
                onDownloadProgress (progress) {
                    that.modals.export.process = "Export in Progress";
                }
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'SorItem.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.modals.export.open = false
            })
            .catch(error => {
                this.modals.export.open = false
                console.log(error);
            });
        },
        /*-- Save Item  --------------------------------*/
        updateItem(){
            this.sorItem.unit_price = this.$accounting.unformat(this.sorItem.unit_price_tmp);
            this.sorItem.is_maintenance = false;
            if(!this.sorItem.sor_group_id
                || !this.sorItem.sor_code
                || !this.sorItem.service_category
                || !this.sorItem.unit_price
            ){
                return this.$alertNotification("Please enter in all the fields", "danger");
            }
            if(this.modal.loading ) return;
            this.modal.loading = true;
            this.$store.dispatch("v2SorController/saveSorItem",this.terms.id)
            .then( data => {
                this.$alertNotification(this.$notificationV2('adding', 'sor'));
                this.$refs.gofixTable.reloadTableKeepFilter();
                this.modal.open = false;
                this.modal.loading = false;
            }).catch(err => {
                this.modal.loading = false;
                if(err.response && err.response.data && err.response.data.error && err.response.data.error.message){
                    this.$alertNotification(err.response.data.error.message.error, "danger");
                    return;
                }
                this.$alertNotification("An error occurred while saving the SOR item.", "danger");
            });
        },

        loadOptionsService({ action, parentNode, callback,instanceId  }){
            if(parentNode.isBatch) {
                this.$store.dispatch("v2SorController/getService",{
                    contract_id:this.$route.params.id,
                    service_id:parentNode.id
                }).then(data => {
                    parentNode.children = data;
                    callback()
                })
            } else{
                parentNode.children = undefined;
                callback()
            }
        },
        normalizerService(node) {
            if(node.data && !node.data.isBatch) {
                return {
                    children : undefined,
                    label: node.name
                }
            }
            return {
                label: node.name
            }
        },
    }
}
</script>
